import { Tag, TagColor } from '@shinetools/lumen-react'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoiceStatus } from '@features/eInvoicing/constants'

import { BillsTableRow } from '../../types/billsTableRow'

type StatusConfig = {
  color: TagColor
  labelKey: string
}

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
const statusToConfigMapping: Record<EInvoiceStatus, StatusConfig> = {
  [EInvoiceStatus.Active]: {
    color: 'blue',
    labelKey: 'To review',
  },
  [EInvoiceStatus.Approved]: {
    color: 'success',
    labelKey: 'Approved',
  },
  [EInvoiceStatus.PaymentReceived]: {
    color: 'success',
    labelKey: 'receipts.receipts_list.type.cashed',
  },
  [EInvoiceStatus.Completed]: {
    color: 'neutral',
    labelKey: 'Completed',
  },
  [EInvoiceStatus.Disputed]: {
    color: 'neutral',
    labelKey: 'Disputed',
  },
  [EInvoiceStatus.Suspended]: {
    color: 'neutral',
    labelKey: 'Suspended',
  },
  [EInvoiceStatus.Refused]: {
    color: 'danger',
    labelKey: 'Refused',
  },
}

interface BillsTableEInvoiceStatusCellProps {
  row: BillsTableRow
}

export const BillsTableEInvoiceStatusCell = ({ row }: BillsTableEInvoiceStatusCellProps): ReactElement | null => {
  const { t } = useTranslation()

  if (!row.eInvoiceStatus) {
    return null
  }

  const config = statusToConfigMapping[row.eInvoiceStatus]

  // Run-time safety check for unknown statuses
  if (!config) {
    return null
  }

  const label = row.eInvoiceStatus === EInvoiceStatus.PaymentReceived ? t(config.labelKey) : config.labelKey

  return <Tag color={config.color} type="subtle" label={label} />
}
